// icon markup on [data-ds-icon].
import { $$, play } from './core.ts';

export function initIcons(): void {
  $$('.ds-ico, .ds-mark').forEach(play);
  document.addEventListener('mouseover', e => {
    const h = (e.target as Element).closest('.ds-nav a, .ds-np, .btn, .ds-mi');
    if (!h || h.contains(e.relatedTarget as Node | null)) return;
    const i = h.querySelector('.ds-ico');
    if (i) play(i);
  });
}
